import React from 'react';
import styles from './Header.module.scss';

import { usePicklistDetailsSelector } from 'hooks/Picklist';
import { useMobileViewport } from 'hooks/useMobileViewport';
import { useHistory } from 'react-router-dom';

import { PICKLIST_EDIT_PATH } from 'constants/routeConstants';

import { ManagementButtons } from './Controls/ManagementButtons';
import { MobileHeaderButtons } from './Controls/MobileHeaderButtons';

export const Header = ({ onAddAssets, onAddAssembly, onRemovePicklist, onStatusChange }) => {
  const history = useHistory();
  const isMobile = useMobileViewport();

  const {
    currentPicklist: { id, name }
  } = usePicklistDetailsSelector();

  if (!name) return null;

  const editPicklist = () => history.push(`${PICKLIST_EDIT_PATH}/${id}`);

  const Title = () => <div className={styles.title}>{name}</div>;
  const PicklistManagementButtons = () => (
    <ManagementButtons
      onEdit={editPicklist}
      onRemove={onRemovePicklist}
      onStatusChange={onStatusChange}
      onAddAssets={onAddAssets}
      onAddAssembly={onAddAssembly}
    />
  );

  const renderButtons = () =>
    isMobile ? (
      <MobileHeaderButtons onEdit={editPicklist} onRemove={onRemovePicklist} />
    ) : (
      <PicklistManagementButtons />
    );

  return (
    <>
      <div className={styles.header}>
        {!isMobile && <Title />}
        {renderButtons()}
      </div>

      {isMobile && <Title />}

      {isMobile && <PicklistManagementButtons />}
    </>
  );
};
